{
  "currentVersion": "1.14.0",
  "versions": [
    {
      "version": "1.14.0",
      "date": "2026-09-18",
      "type": "minor",
      "category": "feature",
      "slug": "ux-projets-brief-admin",
      "title": "Sites web en source de projet, import multiple et brief protégé",
      "summary": "Collez l'adresse d'un site pour l'ajouter comme source d'un projet : Korum en récupère le contenu et en conserve une capture d'écran, prêts à nourrir le brief. L'import accepte désormais plusieurs fichiers en une seule opération, et le brief affiche en direct l'état de vos modifications.",
      "highlights": [
        "Site web en source d'un projet : collez une adresse, Korum en extrait le contenu et en garde une capture d'écran consultable depuis la source, avec le suivi d'analyse habituel (en attente, en cours, analysée) et une cause nommée quand une page reste hors de portée",
        "Import de plusieurs fichiers en une seule opération, par glisser-déposer comme depuis le sélecteur, avec une progression « X sur Y » et le détail des fichiers non retenus",
        "Brief : indicateur de sauvegarde visible pendant la frappe, relance d'analyse ouverte une fois vos modifications enregistrées, et confirmation explicite avant de relancer une source seule ou d'ajouter une adresse déjà présente — effet sur le brief annoncé à l'avance",
        "Lancement d'un débat : chaque protocole s'accompagne de son animation, comme sur la page d'accueil, et la création d'un projet s'ouvre dans une fenêtre illustrée aux codes du produit"
      ],
      "imageUrl": "/assets/changelogs/projects.jpg",
      "imageAlt": "Aperçu d'un projet avec ses sources et son brief"
    },
    {
      "version": "1.13.0",
      "date": "2026-06-09",
      "type": "minor",
      "category": "feature",
      "slug": "ui-names-changelog-settings",
      "title": "Noms des personas partout, notes de version dans l'app et page Compte en onglets",
      "summary": "Les personas s'affichent par leur nom complet sur toutes les surfaces (filtres, transcript, panel de débat, couverture d'un verdict), avec leur profil ouvrable au survol ou au clic. Un lien « Notes de version » dans le pied de page ouvre les nouveautés sans quitter Korum, et la page Compte s'organise en onglets « Compte » et « Facturation ».",
      "highlights": [
        "Nom complet de chaque persona affiché partout — filtre participant des verdicts, transcript, panel de débat, grille de couverture — à la place de son identifiant court",
        "Survolez ou cliquez n'importe quel nom de persona pour ouvrir sa fiche de profil, sans changer de page",
        "Lien « Notes de version » dans le pied de page de l'application : une fenêtre dédiée réunit les nouveautés de Korum, version courante en évidence, du plus récent au plus ancien",
        "Page Compte réorganisée en deux onglets visibles d'emblée, sans défilement : « Compte » (profil, préférences, confidentialité, session) et « Facturation » (plan, factures, abonnement)",
        "Interface traduite en français et en anglais, navigable au clavier et compatible lecteurs d'écran"
      ],
      "imageUrl": "/assets/changelogs/ui-polish-batch.jpg",
      "imageAlt": "Améliorations transverses de l'interface Korum"
    },
    {
      "version": "1.12.0",
      "date": "2026-06-09",
      "type": "minor",
      "category": "feature",
      "slug": "persona-project-rebuild",
      "title": "Brief de projet généré depuis vos sources et historique des personas",
      "summary": "Importez des sources dans un projet et Korum en compose un brief consolidé, lisible par vos personas pendant les débats, enrichi à chaque nouvelle source. La fiche de chaque persona réunit désormais l'historique de ses débats et des verdicts où elle apparaît.",
      "highlights": [
        "Onglet « Brief » sur chaque projet : un brief rédigé automatiquement à partir de vos sources importées, enrichi de façon additive à chaque nouvel ajout",
        "Brief éditable à la main et lié à ses sources : cliquez un passage pour ouvrir directement la source citée",
        "Statut d'analyse visible sur chaque source (en attente, en cours, analysée), mis à jour en direct, avec relance d'une source seule ou de l'analyse complète",
        "Fiche persona enrichie : liste des débats auxquels elle a participé (protocole et avancement) et des verdicts où elle est citée, ouvrables en un clic",
        "Couverture d'un verdict plus lisible : nom complet et rôle affichés sous chaque persona, avec sa couleur d'identification",
        "Interface traduite en français et en anglais, navigable au clavier et compatible lecteurs d'écran"
      ],
      "imageUrl": "/assets/changelogs/projects.jpg",
      "imageAlt": "Aperçu d'un projet avec son brief généré et ses sources analysées"
    },
    {
      "version": "1.11.0",
      "date": "2026-06-09",
      "type": "minor",
      "category": "feature",
      "slug": "verdict-persona-guidance",
      "title": "Aide contextuelle, export par persona et filtres dans les verdicts",
      "summary": "Chaque section d'un verdict propose une bulle d'aide qui explique ce qu'elle mesure et comment l'exploiter. Vous pouvez copier ou télécharger les données brutes d'une persona en un clic, ouvrir sa fiche depuis n'importe quel nom du transcript, et filtrer la liste des verdicts par projet et par participant.",
      "highlights": [
        "Bulle d'aide sur chaque section du verdict (carte des tensions, engagement par tour, irritants, opportunités, couverture des personas, limites, annexes) : explication du concept et conseil d'usage au survol ou au clavier",
        "Export des données d'une persona en JSON : bouton « Copy JSON » et « Download .json » pour chaque participant, plus un téléchargement groupé de toutes les personas du panel",
        "Survolez ou cliquez n'importe quel nom de persona dans le transcript pour ouvrir sa fiche, avec accès direct à son profil complet",
        "Transcript enrichi : nom réel de chaque persona et indication de la personne à qui elle s'adresse",
        "Liste des verdicts filtrable par projet et par participant, avec filtres mémorisés dans l'adresse pour partager une vue en un lien",
        "Traits du panel de débat tracés de bord à bord pour une lecture plus nette des échanges",
        "Bulles d'aide, fiches et filtres navigables au clavier et compatibles lecteurs d'écran"
      ],
      "imageUrl": "/assets/changelogs/verdicts.jpg",
      "imageAlt": "Aperçu d'un verdict avec une bulle d'aide et l'export d'une persona"
    },
    {
      "version": "1.10.0",
      "date": "2026-06-09",
      "type": "minor",
      "category": "feature",
      "slug": "verdict-ui-evolutions",
      "title": "Ouvrez le profil d'une persona directement depuis un verdict",
      "summary": "Dans un verdict, cliquez sur n'importe quelle persona — depuis la grille de couverture ou le transcript du débat — pour ouvrir une fiche dédiée avec son nom complet, son identifiant, son segment, son rôle et son score de couverture. Les noms des personas s'affichent en clair tout au long du transcript et des rapports de tour.",
      "highlights": [
        "Fiche persona en un clic depuis la grille de couverture du verdict : nom complet, identifiant, segment, rôle et score de couverture réunis dans un panneau dédié",
        "Même fiche accessible depuis chaque ligne du transcript du débat, pour relier instantanément une prise de parole à son auteur",
        "Noms des personas affichés en clair dans le transcript et les rapports de tour, à la place des identifiants courts",
        "Export d'un verdict au format PDF identifié par une icône dédiée, distincte du format Markdown",
        "Titres et sous-titres des sections du verdict affichés en entier, sans coupure",
        "Fiche persona navigable au clavier et compatible lecteurs d'écran"
      ],
      "imageUrl": "/assets/changelogs/verdicts.jpg",
      "imageAlt": "Aperçu d'un verdict avec la fiche persona ouverte depuis la grille de couverture"
    },
    {
      "version": "1.9.0",
      "date": "2026-06-08",
      "type": "minor",
      "category": "feature",
      "slug": "verdicts-rework",
      "title": "Verdicts repensés : lecture en 7 blocs et exploration tour par tour",
      "summary": "Chaque verdict s'ouvre sur une décision claire et se déroule en sept sections lisibles, du verdict décisionnel aux annexes chiffrées. Un graphique d'engagement par tour, une timeline de cartes consultables et une synthèse à la demande de chaque tour vous laissent explorer comment le débat a évolué.",
      "highlights": [
        "Verdict décisionnel mis en avant en haut de page, avec jauge de consensus et niveau de polarisation visibles d'un coup d'œil",
        "Sept sections ordonnées : verdict décisionnel, carte des tensions, irritants priorisés (P0/P1/P2), opportunités émergentes, couverture des personas, limites méthodologiques et annexes chiffrées",
        "Trois niveaux de lecture au choix — Décision, Design, Analyse complète — mémorisés d'une visite à l'autre",
        "Graphique d'évolution de l'engagement tour par tour, avec deltas verts et rouges pour repérer convergence et polarisation",
        "Timeline de cartes par tour : score, écart depuis le tour précédent et aperçu du verbatim, consultables sans rouvrir la salle de débat",
        "Panneau par tour avec synthèse générée à la demande (résumé et points clés), provenance des opportunités (tour et persona) et table de statistiques quantitatives",
        "Interface traduite en français et en anglais, navigable au clavier, compatible lecteurs d'écran et respectueuse des préférences de mouvement réduit"
      ],
      "imageUrl": "/assets/changelogs/verdicts.jpg",
      "imageAlt": "Aperçu d'un verdict en sept blocs avec le graphique d'engagement par tour"
    },
    {
      "version": "1.8.0",
      "date": "2026-06-06",
      "type": "minor",
      "category": "feature",
      "slug": "glass-account-subscription",
      "title": "Gestion de votre plan directement depuis Mon compte",
      "summary": "Un nouvel onglet « Subscription » dans Mon compte réunit le choix de plan et le configurateur : ajustez vos quotas, comparez Studio et Team et pilotez votre formule sans quitter la page. Une touche visuelle plus nette accompagne l'ensemble de l'interface.",
      "highlights": [
        "Nouvel onglet « Subscription » dans Mon compte : cartes Studio et Team, bascule mensuel/annuel et configurateur réunis au même endroit",
        "Configurateur pré-rempli avec vos quotas actuels (workspaces, personas par débat, segments, débats simultanés, personas personnalisées), chaque curseur indiquant votre valeur du moment",
        "Lien « Manage » dans la section Billing pour rejoindre l'onglet Subscription en un clic",
        "Cards translucides sur le dashboard et la page d'accueil, pour une meilleure profondeur visuelle",
        "Modales mises en avant par un arrière-plan flouté qui isole clairement la fenêtre du reste de l'écran",
        "Barre du haut épurée sur les pages qui n'en ont pas besoin, recentrée sur votre fil de navigation",
        "Interface traduite en français et en anglais, navigable au clavier et compatible lecteurs d'écran"
      ],
      "imageUrl": "/assets/changelogs/text-pricing-plan.png",
      "imageAlt": "Aperçu de l'onglet Subscription avec les cartes de plan et le configurateur"
    },
    {
      "version": "1.7.0",
      "date": "2026-06-01",
      "type": "minor",
      "category": "feature",
      "slug": "post-checkout-onboarding",
      "title": "Parcours de bienvenue après souscription, de la confirmation au dashboard",
      "summary": "Après votre souscription à un plan Studio ou Team, un parcours de bienvenue continu vous accueille : confirmation de votre plan, visite guidée de Korum en cinq temps, puis entrée dans votre dashboard d'un seul geste avec le bouton « Ouvrir mon dashboard ».",
      "highlights": [
        "Première étape « Plan confirmé » qui récapitule votre plan souscrit et ses quotas, directement intégrée au parcours de bienvenue",
        "Visite guidée enchaînée en cinq temps : vue d'ensemble, construction de votre panel, regroupement en segments, lancement d'un protocole et lecture du verdict",
        "Étape finale « Ouvrir mon dashboard » : un bouton dédié vous emmène dans votre workspace quand vous êtes prêt",
        "Indicateur de progression clair tout au long du parcours, navigable au clavier et compatible lecteurs d'écran",
        "Interface traduite en français et en anglais"
      ],
      "imageUrl": "/assets/changelogs/landing.jpg",
      "imageAlt": "Aperçu du parcours de bienvenue après souscription"
    },
    {
      "version": "1.6.0",
      "date": "2026-06-01",
      "type": "minor",
      "category": "feature",
      "slug": "persona-edit-duplicate",
      "title": "Édition de personas et duplication directe en mode édition",
      "summary": "Modifiez vos personas depuis une page d'édition dédiée, et dupliquez n'importe quelle persona — y compris celles de la bibliothèque — pour atterrir directement sur la copie en mode édition. Une protection des modifications non sauvegardées vous évite de perdre votre travail en quittant le formulaire.",
      "highlights": [
        "Page d'édition de persona : nom, rôle, bio, objectifs, frictions, tics de langage, style de décision et radar de traits ajustables au même endroit",
        "Validation champ par champ avec messages d'erreur sous chaque champ concerné, et bouton « Save changes » actif uniquement quand un changement est détecté",
        "Bouton « Duplicate persona » accessible depuis chaque card et depuis la page de détail, y compris pour les personas de la bibliothèque",
        "Duplication d'une persona de la bibliothèque : une fenêtre de confirmation explique qu'une copie éditable est créée dans votre workspace, l'originale restant inchangée",
        "Après duplication, arrivée directe sur la copie en mode édition pour la personnaliser sans étape intermédiaire",
        "Garde des modifications non sauvegardées : une confirmation s'affiche avant de quitter le formulaire avec des changements en cours",
        "Interface traduite en français et en anglais, navigable au clavier et compatible lecteurs d'écran"
      ],
      "imageUrl": "/assets/changelogs/personas.jpg",
      "imageAlt": "Aperçu de l'édition d'une persona avec son radar de traits"
    },
    {
      "version": "1.5.0",
      "date": "2026-06-01",
      "type": "minor",
      "category": "feature",
      "slug": "plan-checkout-to-account",
      "title": "Du choix de plan à votre compte en un parcours continu",
      "summary": "Un clic sur le plan Studio ou Team vous emmène directement au paiement, puis sur votre compte où une fenêtre de confirmation récapitule votre souscription. La section Billing met en avant les caractéristiques de votre plan et propose de changer de formule ou de passer à une offre sur mesure.",
      "highlights": [
        "Clic sur Studio ou Team : inscription puis paiement s'enchaînent automatiquement avec le bon cycle, et l'arrivée se fait directement sur votre compte, section Billing en évidence",
        "Fenêtre de confirmation après paiement : plan souscrit, cycle et statut réunis d'un coup d'œil, avec accès direct au workspace ou au détail de facturation",
        "Bloc « Plan details » dans Billing : workspaces, personas par débat, segments, débats simultanés et personas personnalisées inclus dans votre plan, lisibles en un regard",
        "Bouton « Change plan » pour passer de Studio à Team (ou inversement) et bouton « Upgrade to custom » pour composer une offre sur mesure",
        "Interface traduite en français et en anglais, navigable au clavier et compatible lecteurs d'écran"
      ],
      "imageUrl": "/assets/changelogs/text-pricing-plan.png",
      "imageAlt": "Aperçu de la section Billing avec le détail du plan souscrit"
    },
    {
      "version": "1.4.0",
      "date": "2026-05-27",
      "type": "minor",
      "category": "feature",
      "slug": "billing-confirm-invoices-cycle",
      "title": "Confirmation de plan, historique de factures et bascule mensuel/annuel",
      "summary": "Après une souscription, une page de confirmation dédiée récapitule votre plan, son cycle, le montant et la date de prochaine facturation. La section Billing de votre compte affiche désormais l'historique de vos factures et permet de passer du cycle mensuel au cycle annuel (ou inversement) sans quitter Korum.",
      "highlights": [
        "Page de confirmation après souscription : nom du plan, cycle, montant et date de prochaine facturation réunis en un coup d'œil, avec accès direct au workspace ou à la section Billing",
        "Variante d'essai : la confirmation indique le statut trial, la date de fin et les jours restants",
        "Historique des factures dans Mon compte : date, montant et statut de chaque facture, avec ouverture de la facture en ligne et téléchargement du PDF en un clic",
        "Bascule entre facturation mensuelle et annuelle directement depuis la section Billing, via une fenêtre de confirmation qui affiche le montant proratisé avant validation",
        "Interface traduite en français et en anglais, navigable au clavier et compatible lecteurs d'écran"
      ],
      "imageUrl": "/assets/changelogs/text-pricing-plan.png",
      "imageAlt": "Aperçu de la section Billing avec confirmation de plan et historique de factures"
    },
    {
      "version": "1.3.0",
      "date": "2026-05-27",
      "type": "minor",
      "category": "feature",
      "slug": "pricing-stripe-checkout",
      "title": "Souscription Studio et Team en une seule étape depuis le pricing",
      "summary": "Un clic sur le plan Studio ou Team ouvre directement le checkout sécurisé, depuis la page d'accueil comme depuis « Configure your plan ». Le configurateur sur mesure et le formulaire de contact gagnent en clarté pour composer son offre et joindre l'équipe sans détour.",
      "highlights": [
        "Plans Studio et Team : le bouton « Start free trial » mène directement au checkout sécurisé, en une seule étape, sur la page d'accueil comme sur « Configure your plan »",
        "Si vous n'êtes pas encore connecté, l'inscription enchaîne automatiquement sur le checkout du plan choisi, avec le bon cycle de facturation (mensuel ou annuel)",
        "Configurateur sur mesure : bouton renommé « Start custom plan » pour indiquer clairement qu'il lance la souscription de votre configuration",
        "Formulaire de contact repositionné en bas de la page « Configure your plan », sous le comparatif des plans, dans sa propre section pleine largeur",
        "Formulaire de devis allégé : champs recentrés sur l'essentiel pour une demande plus rapide à remplir"
      ],
      "imageUrl": "/assets/changelogs/text-pricing-plan.png",
      "imageAlt": "Aperçu du pricing avec souscription directe aux plans Studio et Team"
    },
    {
      "version": "1.2.0",
      "date": "2026-05-26",
      "type": "minor",
      "category": "feature",
      "slug": "configure-plan-quote-contact",
      "title": "Page « Configure your plan » : configurateur et formulaire côte à côte",
      "summary": "Sur la page « Configure your plan », le configurateur de devis et le formulaire de contact s'affichent désormais côte à côte : réglez vos paramètres à gauche et envoyez votre demande à droite, sans scroller. Les cartes Studio et Team présentent leurs limites sur les mêmes axes que le configurateur.",
      "highlights": [
        "Configurateur de devis et formulaire de contact présentés en deux colonnes côte à côte sur desktop, empilés proprement sur mobile",
        "Vos réglages de sliders se reportent automatiquement dans la demande envoyée par le formulaire",
        "Cartes Studio et Team décrites sur les mêmes critères que le configurateur : workspaces, personas par débat, segments, débats simultanés et personas personnalisées",
        "FAQ de la page d'accueil clairement détachée de la grille tarifaire pour une lecture plus aérée",
        "Formulaire de devis simplifié et entièrement traduit en français, anglais, espagnol et portugais"
      ],
      "imageUrl": "/assets/changelogs/text-pricing-plan.png",
      "imageAlt": "Aperçu de la page Configure your plan en deux colonnes"
    },
    {
      "version": "1.1.0",
      "date": "2026-05-26",
      "type": "minor",
      "category": "feature",
      "slug": "landing-configure-plan",
      "title": "Section pricing épurée et page de configuration de plan enrichie",
      "summary": "La section pricing de la page d'accueil va droit au but avec trois cartes côte à côte — Studio, Team et Configure — et la carte Configure ouvre en un clic la page « Configure your plan ». Cette page réunit désormais le configurateur de prix et un tableau comparatif détaillé des plans, le tout entièrement traduit.",
      "highlights": [
        "Section pricing de la page d'accueil resserrée sur trois cartes lisibles d'un coup d'œil : Studio, Team et Configure, avec un badge « Most popular » sur le plan Team",
        "Carte Configure qui mène directement à la page « Configure your plan » pour composer son offre sur mesure à partir du configurateur",
        "Tableau comparatif des plans (Studio, Team, Custom) regroupé sur la page « Configure your plan », au plus près du configurateur de prix, avec des valeurs claires dans chaque cellule",
        "Tableau recentré sur les critères self-serve : workspaces inclus, personas par débat, segments, débats simultanés, débats inclus par mois, dépassement et personas personnalisées",
        "Page et tableau entièrement traduits en français, anglais, espagnol et portugais"
      ],
      "imageUrl": "/assets/changelogs/text-pricing-plan.png",
      "imageAlt": "Aperçu de la page de configuration de plan avec son tableau comparatif"
    },
    {
      "version": "1.0.0",
      "date": "2026-05-26",
      "type": "major",
      "category": "feature",
      "slug": "card-trial-configurator",
      "title": "Souscription en libre-service depuis le configurateur et trial avec carte",
      "summary": "Le configurateur de plan devient un parcours d'achat complet : ajustez vos quotas, voyez le prix se calculer en direct et souscrivez en un clic via un checkout Stripe sécurisé. Le trial de 14 jours s'active avec une carte enregistrée, et le bandeau d'essai affiche en permanence la date et le montant du premier prélèvement.",
      "highlights": [
        "Bouton « Subscribe now — [prix]/mo » directement sous le configurateur : un clic ouvre un checkout Stripe avec le prix calculé en temps réel à partir de vos quotas (workspaces, personas par débat, segments, débats par mois, personas personnalisées)",
        "Quotas sur-mesure appliqués immédiatement à votre workspace après souscription, avec un récapitulatif clair dans la confirmation",
        "Trial de 14 jours adossé à une carte bancaire : la carte est enregistrée sans débit immédiat, et votre plan démarre automatiquement à la fin de l'essai",
        "Bandeau d'essai enrichi : nombre de jours restants, date exacte et montant du premier prélèvement (« Trial · 14 days remaining · 49 € due on 9 juin 2026 »), avec accès direct à la gestion de la facturation",
        "Configurations plus larges : un bouton « Contact us for a quote » envoie votre demande et vous recevez par email un lien de paiement sécurisé prêt à finaliser, à usage unique",
        "Modification de plan en libre-service depuis le configurateur, avec affichage du prorata avant confirmation",
        "Prix affiché et facturé dans la devise de votre langue (dollars en anglais, euros en français), sans conversion surprise, avec mention explicite de la devise"
      ],
      "imageUrl": "/assets/changelogs/text-pricing-plan.png",
      "imageAlt": "Aperçu du configurateur de plan avec le bouton de souscription"
    },
    {
      "version": "0.39.0",
      "date": "2026-05-25",
      "type": "minor",
      "category": "feature",
      "slug": "self-serve-billing-trial",
      "title": "Trial 14 jours et achat en libre-service des plans Studio et Team",
      "summary": "Inscrivez-vous en quelques secondes et démarrez immédiatement un essai de 14 jours sans carte bancaire, ou souscrivez directement au plan Studio ou Team depuis la page pricing. Une nouvelle section « Billing » dans votre compte centralise plan, paiement et changements de formule, et un bandeau dédié vous indique en permanence où vous en êtes de votre trial.",
      "highlights": [
        "Trial de 14 jours activé automatiquement à l'inscription, sans carte bancaire à renseigner : 5 débats, 10 personas et 1 workspace inclus pour explorer Korum",
        "Boutons « Choose Studio » et « Choose Team » actifs sur la page « Configure your plan » : un clic ouvre directement un checkout Stripe sécurisé avec le bon cycle (mensuel ou annuel)",
        "Bandeau de trial persistant en haut de l'application : indication claire du nombre de jours restants, signal vert quand il reste 3 jours ou moins, et bouton « Upgrade plan » toujours à portée",
        "Bloc « Upgrade plan » affiché à la place du CTA dès qu'un quota du trial est atteint (débats, personas, workspaces) avec un message explicite et un accès direct au choix de plan",
        "Nouvelle section « Billing » dans Mon compte : plan actuel, statut, date de prochain renouvellement, montant de la prochaine facture, et accès au Stripe Customer Portal pour changer de moyen de paiement",
        "Upgrade et downgrade entre Studio et Team gérés depuis le compte, avec affichage du prorata avant confirmation et application immédiate",
        "Annulation de plan en libre-service depuis le compte, avec modale de confirmation explicite : le plan reste actif jusqu'à la fin de la période payée",
        "Email de relance à J-3 avant la fin du trial avec un rappel du verdict produit dans le workspace, et email de réactivation après 7 jours d'inactivité avec un lien pour échanger avec l'équipe",
        "Email automatique en cas d'échec de paiement, avec lien direct pour mettre à jour le moyen de paiement avant l'expiration de la période de grâce",
        "Inscription protégée par un captcha hCaptcha et limitée aux emails professionnels pour garantir la qualité des comptes",
        "Devise adaptée à la langue de navigation (USD pour EN/PT, EUR pour FR/ES), interface entièrement traduite en français, anglais, espagnol et portugais"
      ],
      "imageUrl": "/assets/changelogs/landing.jpg",
      "imageAlt": "Aperçu de la page pricing avec les CTA Studio et Team actifs"
    },
    {
      "version": "0.38.0",
      "date": "2026-05-25",
      "type": "minor",
      "category": "feature",
      "slug": "pricing-page-redesign",
      "title": "Pricing repensé : calculateur interactif, comparatif détaillé et FAQ d'achat",
      "summary": "La section pricing de la page d'accueil propose désormais un calculateur de prix interactif visible d'entrée, trois plans recalibrés (Studio 49 €/seat/mo, Team 149 €/seat/mo, Custom à partir de 1 200 €/mo · 10 seats inclus), une comparaison directe avec les alternatives du marché, un tableau comparatif détaillé, une FAQ ciblée sur les principales questions d'achat et un appel à l'action toujours accessible en bas d'écran.",
      "highlights": [
        "Calculateur interactif en tête de section : trois curseurs (seats, workspaces, débats par mois) qui ajustent en direct le prix estimé et le plan recommandé entre Studio, Team et Custom",
        "Trois plans recalibrés côte à côte : Studio à 49 €/seat/mo, Team à 149 €/seat/mo, Custom à partir de 1 200 €/mo avec 10 seats inclus",
        "Bascule Mensuel / Annuel enrichie : badge « 2 mois offerts » et message clair « 10 mois facturés, 12 mois d'usage · −17 % » au passage en annuel",
        "Encart « What you'd pay otherwise » : comparaison directe avec un cycle de recherche UX freelance (~1 950 €) et un panel quali recruté (3 000–8 000 €), pour situer la valeur de Korum",
        "Tableau comparatif de 10 lignes entre Studio, Team et Custom : workspaces inclus, personas par débat, segments, débats simultanés, débats inclus par mois, dépassement, personas custom, accès API, SSO/SAML, SLA et CSM",
        "FAQ de 6 questions d'achat : stockage des données, conformité RGPD, fiabilité des panels de personas, éligibilité au trial, règles de downgrade, comportement en cas de dépassement de quota",
        "Bouton « Start free trial » figé en bas d'écran pendant tout le parcours pricing, qui mute en « Open Korum » pour les membres déjà connectés et achemine directement vers le dashboard",
        "Carte Custom dotée d'un lien « Book a call » dédié pour réserver un échange en un clic, en complément de l'accès au configurateur de plan",
        "Page disponible en quatre langues : français, anglais, espagnol et portugais, avec un sélecteur de langue mis à jour en conséquence",
        "Navigation au clavier complète sur les curseurs, le toggle, les accordéons FAQ et le tableau comparatif, avec respect des préférences de mouvement réduit"
      ],
      "imageUrl": "/assets/changelogs/text-pricing-plan.png",
      "imageAlt": "Aperçu de la section pricing avec calculateur et trois plans"
    },
    {
      "version": "0.37.0",
      "date": "2026-05-24",
      "type": "minor",
      "category": "feature",
      "slug": "recherche-globale",
      "title": "Recherche globale instantanée dans tout le workspace",
      "summary": "Une nouvelle recherche globale permet de retrouver en quelques frappes n'importe quelle persona, segment, projet, débat ou verdict du workspace actif. Elle s'ouvre via le raccourci Ctrl+K (ou Cmd+K sur Mac), depuis le champ de recherche de la barre latérale, ou depuis l'icône loupe de la topbar mobile.",
      "highlights": [
        "Raccourci clavier Ctrl+K / Cmd+K disponible depuis n'importe quelle page de l'application pour ouvrir la recherche en un geste",
        "Champ de recherche de la barre latérale renommé « Search workspace… » : un clic ouvre la même fenêtre de recherche globale, avec un badge ⌘K bien visible",
        "Topbar mobile dotée d'un bouton loupe dédié qui ouvre la recherche en plein écran avec un slide-up depuis le bas",
        "Résultats groupés par type et présentés dans un ordre stable (Personas, Segments, Projects, Debates, Verdicts), avec icône, nom et identifiant court (P-04, SEG-02, DEB-07…)",
        "Filtrage en temps réel avec tri par pertinence (les noms qui commencent par votre requête remontent en haut) et plafond de 5 résultats par type pour garder la liste lisible",
        "Navigation entièrement au clavier dans la liste : flèches haut/bas pour parcourir, Entrée pour ouvrir, Échap pour fermer, avec mise en évidence claire de la ligne sélectionnée (fond teinté + liseré gauche)",
        "Empty state explicite quand aucun résultat ne correspond, et message dédié avec bouton « Try again » en cas de problème de connexion",
        "Dashboard : rail des personas désormais bordé d'un dégradé à gauche dès qu'on fait défiler horizontalement, en symétrie avec le dégradé droit, pour signaler qu'il reste du contenu à découvrir",
        "Barre latérale épurée : l'ancien bouton « New panel » a été retiré pour laisser plus de place à la liste des panels",
        "Interface entièrement traduite en français et en anglais, accessible aux lecteurs d'écran, avec respect des préférences de mouvement réduit"
      ],
      "imageUrl": "/assets/changelogs/ui-polish-batch.jpg",
      "imageAlt": "Aperçu de la recherche globale ouverte avec ses résultats groupés"
    },
    {
      "version": "0.36.0",
      "date": "2026-05-24",
      "type": "minor",
      "category": "feature",
      "slug": "ui-polish-debate-personas",
      "title": "Salle de débat, export de verdict et liste de personas peaufinés",
      "summary": "La salle de débat répond instantanément à la mise en pause et propose la suppression directe sans étape intermédiaire. L'export d'un verdict se choisit dans une fenêtre dédiée avec deux formats côte à côte. La liste des personas affiche le nom complet de chaque segment, avec les personas non assignées en fin de liste. Les cartes de verdicts du dashboard respirent enfin avec un espacement régulier.",
      "highlights": [
        "Salle de débat : un clic sur « Pause debate » bascule immédiatement le badge d'état en « Paused », avec bannière de confirmation et reprise possible à tout moment",
        "Salle de débat : « Delete debate » accessible directement depuis le menu d'options pour les débats en cours ou en seeding, sans passer par une mise en pause préalable, toujours protégée par la modale de confirmation à compte à rebours",
        "Export d'un verdict : nouvelle fenêtre dédiée avec deux cartes côte à côte (Markdown et PDF), chaque format illustré par son icône et accompagné d'une courte description pour choisir en un coup d'œil",
        "Export d'un verdict : les deux formats peuvent être lancés en parallèle, chaque carte gère son propre indicateur de progression sans bloquer l'autre",
        "Export d'un verdict : sous-titre indiquant le nombre d'insights à exporter directement dans l'en-tête de la fenêtre",
        "Liste des personas : chaque groupe affiche désormais le nom complet du segment en plus de son identifiant (ex. « EARLY ADOPTERS · SEG-01 · 8 PERSONAS »)",
        "Liste des personas : le groupe « Unassigned · SEG-00 » apparaît en fin de liste, après tous les segments nommés, pour retrouver d'abord les personas organisées intentionnellement",
        "Dashboard : espacement cohérent entre chaque carte de verdict dans le bloc « Recent verdicts », alignement visuel régulier sur toutes les résolutions",
        "Interface entièrement traduite en français et en anglais, navigation au clavier complète et respect des préférences de mouvement réduit"
      ],
      "imageUrl": "/assets/changelogs/debates.jpg",
      "imageAlt": "Aperçu de la salle de débat avec le menu d'options et la fenêtre d'export"
    },
    {
      "version": "0.35.0",
      "date": "2026-05-24",
      "type": "minor",
      "category": "feature",
      "slug": "debate-pause-cancel-controls",
      "title": "Pause, reprise et suppression d'un débat depuis la liste et la salle",
      "summary": "Un nouveau menu d'options réunit les actions clés d'un débat — Ouvrir, Mettre en pause, Reprendre, Supprimer — directement accessible depuis chaque carte de la liste des débats et depuis la salle de débat. Les titres de cartes longs sont désormais limités à deux lignes et révèlent leur nom complet au survol.",
      "highlights": [
        "Menu d'options sur chaque carte de la liste Debates : bouton « … » qui apparaît au survol (ou toujours visible sur tactile) et propose les actions disponibles selon l'état du débat",
        "Depuis une carte « Live » ou « Seeding » : actions « Open debate » et « Pause debate » en deux clics, sans avoir à entrer dans la salle",
        "Depuis une carte « Paused » : actions « Open debate », « Resume debate » et « Delete debate » directement sur la carte",
        "Salle de débat : les anciens boutons Stop et Resume sont remplacés par un menu d'options unifié qui regroupe Pause, Resume et Delete selon le moment, avec une transition douce entre les états",
        "Suppression toujours protégée par la modale de confirmation avec compte à rebours de 3 secondes pour éviter tout clic accidentel",
        "Cartes plus régulières : titres de débats limités à deux lignes, avec un tooltip qui dévoile le nom complet au survol quand il est tronqué",
        "Navigation au clavier complète sur les menus (flèches, Entrée, Échap), libellés traduits en français et en anglais, respect des préférences de mouvement réduit"
      ],
      "imageUrl": "/assets/changelogs/debates.jpg",
      "imageAlt": "Aperçu d'une carte de débat avec son menu d'options ouvert"
    },
    {
      "version": "0.34.0",
      "date": "2026-05-24",
      "type": "minor",
      "category": "feature",
      "slug": "onboarding-protocol-preview",
      "title": "Tutoriel d'accueil en 5 étapes et aperçu du protocole sur le lancement de débat",
      "summary": "Les nouveaux membres sont accueillis par un tutoriel illustré en cinq étapes qui présente Korum de bout en bout. Sur la page de lancement d'un débat, le protocole choisi affiche désormais une description dédiée et une frise des phases à venir pour décider en connaissance de cause.",
      "highlights": [
        "Tutoriel d'accueil interactif en cinq étapes (Vue d'ensemble, Création de persona, Création de segment, Lancement de débat, Lecture du verdict), illustré et navigable avec un indicateur de progression « 01 / 05 »",
        "Réouverture du tutoriel à tout moment depuis un lien « How Korum works » ajouté dans la barre latérale",
        "Page de lancement de débat : nouveau sélecteur de protocole avec quatre cartes (Devil's Advocate, Jobs-to-be-Done, Critique Round, Custom protocol) et une description dédiée qui se met à jour à chaque sélection",
        "Frise « Protocol phases » placée en tête du formulaire de lancement, qui montre les phases du débat à venir (Seeding, Opening round, Running, Complete) avec la première étape déjà mise en avant",
        "Navigation au clavier complète sur le tutoriel : flèches gauche/droite pour avancer, Échap pour fermer, focus immédiat sur l'action principale",
        "Affichage soigné en plein écran sur mobile et en deux colonnes sur desktop, avec respect des préférences de mouvement réduit"
      ],
      "imageUrl": "/assets/changelogs/debates.jpg",
      "imageAlt": "Aperçu du lancement de débat avec la frise des phases et le sélecteur de protocole"
    },
    {
      "version": "0.33.0",
      "date": "2026-05-22",
      "type": "minor",
      "category": "feature",
      "slug": "refonte-verdicts-dashboard",
      "title": "Verdicts enrichis et dashboard « Recent verdicts » repensé",
      "summary": "Les rapports de verdicts gagnent trois nouvelles lectures — Jobs-to-be-Done, Coalitions et Fracture lines — accessibles depuis la page verdict privée comme depuis les liens de verdict partagés. Sur le dashboard, le bloc « Recent verdicts » adopte une hauteur calibrée alignée avec le bloc d'activité voisin, un scroll vertical doux avec fondus en haut et en bas et un chargement progressif des cartes.",
      "highlights": [
        "Trois nouveaux onglets sur la page verdict : Jobs-to-be-Done, Coalitions et Fracture lines, avec des messages dédiés quand l'analyse n'a rien à afficher pour une rubrique",
        "Verdicts partagés publiquement : les destinataires d'un lien de verdict voient désormais les cinq onglets complets (Insights, Frictions, Jobs-to-be-Done, Coalitions, Fracture lines), exactement comme dans l'application",
        "Bloc « Recent verdicts » du dashboard à hauteur calibrée (deux cartes pleines et la troisième en aperçu), parfaitement aligné avec le bloc « Activity » à sa droite",
        "Scroll vertical fluide à l'intérieur du bloc, avec un fondu en haut et en bas qui indique en un coup d'œil qu'il reste des verdicts à découvrir",
        "Chargement progressif des cartes de verdict du dashboard au fil du défilement, pour une page principale plus légère et plus réactive",
        "Bloc « Activity » du dashboard aligné sur le même comportement de scroll et de fondu, pour une cohérence visuelle parfaite entre les deux colonnes",
        "Interface entièrement traduite en français et en anglais, accessible au clavier et aux lecteurs d'écran"
      ],
      "imageUrl": "/assets/changelogs/verdicts.jpg",
      "imageAlt": "Aperçu d'un verdict avec ses onglets d'analyse"
    },
    {
      "version": "0.32.0",
      "date": "2026-05-22",
      "type": "minor",
      "category": "feature",
      "slug": "debate-report-verdicts",
      "title": "Page Verdicts : tous les rapports de débats en un seul endroit",
      "summary": "Une nouvelle page « Verdicts » centralise l'ensemble des rapports de vos débats terminés. Retrouvez chaque verdict d'un coup d'œil avec son score de consensus, ses insights, ses frictions et le panel de personas, et ouvrez le rapport complet en un clic.",
      "highlights": [
        "Liste complète des verdicts du workspace, triés du plus récent au plus ancien, sans dépendre du dashboard",
        "Chaque carte affiche : identifiant court du débat (DEB-NNN), nom, protocole utilisé, score de consensus (Consensus / Divisé / Non concluant / Conflit), compteurs d'insights et de frictions, avatars des personas du panel et date relative",
        "Recherche instantanée par nom de débat ou identifiant court pour retrouver un verdict précis sans faire défiler",
        "Verdict en cours de génération signalé par un état dédié « Generating verdict… » qui se met à jour automatiquement dès que le rapport est prêt",
        "Clic sur une carte pour ouvrir le verdict complet (stats, insights, frictions, JTBD, coalitions, fracture lines, recommandations) et lien « Back to verdicts » pour revenir à la liste",
        "Interface entièrement traduite en français et en anglais, accessible au clavier et aux lecteurs d'écran"
      ],
      "imageUrl": "/assets/changelogs/verdicts.jpg",
      "imageAlt": "Aperçu de la page Verdicts listant les rapports de débats"
    },
    {
      "version": "0.31.0",
      "date": "2026-05-20",
      "type": "minor",
      "category": "feature",
      "slug": "theme-readability-pass",
      "title": "Lisibilité renforcée en thème clair et sombre sur toute l'application",
      "summary": "Une passe de finition harmonise les contrastes de l'interface : labels, bordures, dropdowns, tableaux, modales et champs de saisie s'affichent avec un contraste optimal quel que soit le thème actif, et la bascule clair/sombre est désormais fluide sur l'ensemble des écrans.",
      "highlights": [
        "Page Projects : tableau des panels avec en-têtes, lignes et bordures parfaitement contrastés en thème clair comme en thème sombre",
        "Champs de saisie (texte, recherche, mot de passe, sélecteurs, zones de texte) : labels, valeurs, placeholders et bordures lisibles dans les deux thèmes",
        "Lancement de débat : sélecteurs de projet et de panel avec libellés, valeurs et chips affichés au bon niveau de contraste",
        "ThemeSwitcher et sélecteur de langue : option active clairement distinguée de l'option inactive dans les deux thèmes",
        "Modales (ajout de témoin, suppression de workspace, suppression d'artefact, suppression de débat…) : fonds, textes et séparateurs cohérents avec le thème choisi",
        "Bibliothèque de sources d'un projet : barre de recherche, menu de tri et zone de dépôt parfaitement lisibles en clair comme en sombre",
        "Bascule clair/sombre adoucie : transition de fond et de texte uniforme sur l'ensemble des surfaces, sans rupture visuelle"
      ],
      "imageUrl": "/assets/changelogs/ui-polish-batch.jpg",
      "imageAlt": "Aperçu de l'interface Korum en thème clair et thème sombre"
    },
    {
      "version": "0.30.0",
      "date": "2026-05-20",
      "type": "minor",
      "category": "feature",
      "slug": "project-artifacts-viewer",
      "title": "Sources de projet : preview, recherche et suppression directes",
      "summary": "Les sources attachées à un projet (briefs, transcripts, screenshots, vidéos, audio, liens) gagnent une véritable bibliothèque : preview adaptée à chaque type de fichier, recherche instantanée, regroupement par média et suppression sécurisée depuis un panneau dédié.",
      "highlights": [
        "Sources regroupées par type (IMAGE, TEXTE, VIDEO, AUDIO, LIEN) avec compteur par groupe, tri local par extension ou date d'ajout et repli/dépli en un clic",
        "Champ de recherche instantané pour filtrer par nom, type ou extension, avec un état dédié et un bouton « Effacer la recherche » quand aucune source ne correspond",
        "Panneau de visualisation latéral (desktop) ou plein-écran (mobile) qui s'adapte au fichier : image en taille réelle avec zoom lightbox, lecteur audio et vidéo intégrés, aperçu de lien externe",
        "Lecture des fichiers texte et code (JSON, Markdown, YAML, CSV, TS, JS, HTML, CSS, XML…) avec coloration syntaxique en JetBrains Mono",
        "Fichiers Markdown : bascule « Source / Preview » pour lire le brief en rendu naturel ou en code, choix mémorisé pendant la session",
        "Bouton « Remove source » sur chaque carte et dans le panneau, avec dialog de confirmation et compte à rebours de 3 secondes pour éviter toute suppression accidentelle",
        "État d'erreur dédié avec bouton « Réessayer » si le chargement des sources échoue, et message explicite pour les liens dont l'URL n'est pas valide",
        "Interface entièrement traduite en français et en anglais, accessible au clavier et aux lecteurs d'écran"
      ],
      "imageUrl": "/assets/changelogs/projects.jpg",
      "imageAlt": "Aperçu d'un projet avec ses sources groupées par type"
    },
    {
      "version": "0.29.0",
      "date": "2026-05-20",
      "type": "minor",
      "category": "feature",
      "slug": "debate-live-timeline-ux",
      "title": "Salle de débat enrichie : timeline des phases et lecture en direct du panel",
      "summary": "La salle de débat gagne une lecture limpide de la progression : une timeline horizontale affiche les phases du débat, chaque persona du canvas porte son nom et son identifiant, et les nouvelles prises de parole s'insèrent par le haut du transcript. Dès qu'un débat est terminé, un bouton « View verdict » mène directement à l'analyse.",
      "highlights": [
        "Nouvelle timeline horizontale au-dessus du canvas (Seeding · Opening round · Running · Complete) avec phase active mise en avant, repère dédié pour les états en pause et les débats échoués",
        "Chaque puce de persona dans le canvas affiche son nom complet et son identifiant (ex. SYS-11) en dessous, avec un halo animé et un label « Deliberating… » sur la persona qui prend la parole",
        "Au survol d'une puce, une fiche persona apparaît au-dessus avec un bouton « Open persona » qui ouvre le profil détaillé dans un nouvel onglet",
        "Les nouvelles prises de parole arrivent désormais par le haut du transcript avec une transition douce, sans faire défiler la liste ni faire perdre le fil",
        "Bouton « View verdict » mis en avant dans le bandeau de la salle dès qu'un débat est terminé, et lien équivalent ajouté dans le footer des cartes de débats terminés sur la page Debates",
        "Bannière dédiée quand un débat est mis en pause, message d'erreur explicite si la session échoue, et respect des préférences de mouvement réduit du système"
      ],
      "imageUrl": "/assets/changelogs/debates.jpg",
      "imageAlt": "Aperçu de la salle de débat avec timeline des phases et panel de personas"
    },
    {
      "version": "0.28.0",
      "date": "2026-05-19",
      "type": "minor",
      "category": "feature",
      "slug": "debate-stop-delete",
      "title": "Arrêt et suppression d'un débat depuis la salle de débat",
      "summary": "Vous pouvez désormais mettre un débat en pause directement depuis la salle de débat, puis le supprimer définitivement après une confirmation protégée. Idéal pour clore proprement une session lancée par erreur ou partie dans la mauvaise direction.",
      "highlights": [
        "Nouveau bouton « Stop debate » dans le bandeau de la salle de débat : un clic met la session en pause et bascule l'indicateur d'état en conséquence",
        "En pause, un bouton « Delete debate » apparaît à côté de « Resume » pour engager la suppression définitive",
        "Modale de confirmation dédiée avec compte à rebours de 3 secondes sur le bouton de validation, pour éviter toute suppression accidentelle",
        "Récapitulatif clair avant suppression : nom du débat, identifiant court (DEB-NNN), nombre de tours enregistrés et durée écoulée depuis le lancement",
        "Après confirmation, retour automatique à la liste des débats accompagné d'un message « Debate deleted. »",
        "Interface entièrement traduite en français et en anglais, accessible au clavier et aux lecteurs d'écran"
      ],
      "imageUrl": "/assets/changelogs/debates.jpg",
      "imageAlt": "Aperçu de la salle de débat avec les actions Stop et Delete"
    },
    {
      "version": "0.27.0",
      "date": "2026-05-19",
      "type": "minor",
      "category": "feature",
      "slug": "mobile-nav-landing-polish",
      "title": "Navigation mobile dédiée et page d'accueil thématisée",
      "summary": "L'application gagne une navigation pensée pour mobile, avec une barre d'onglets en bas et un en-tête compact pour changer de workspace en un geste. La page d'accueil adapte son visuel au thème clair ou sombre, et un bouton dédié permet de basculer entre les deux directement depuis la nav.",
      "highlights": [
        "Sur mobile, une barre de navigation en bas donne accès en un tap aux cinq sections principales : Dashboard, Debates, Personas, Projects et Verdicts",
        "Nouvel en-tête mobile avec la marque Korum à gauche et un sélecteur de workspace à droite, ouvrant le même picker que sur desktop",
        "Bascule entre thème clair et sombre désormais accessible depuis la barre de navigation de la page d'accueil, sur desktop comme dans le drawer mobile",
        "Page d'accueil : visuel de fond du hero adapté automatiquement au thème choisi (dégradé bleu-blanc en clair, bleu nuit en sombre), avec un fondu doux à chaque bascule",
        "Page d'accueil : affichage stable sur toutes les tailles d'écran (320 px à 1440 px), de la table ronde à la citation animée",
        "Respect des préférences de mouvement réduit du système : les transitions s'effacent automatiquement pour les utilisateurs concernés"
      ],
      "imageUrl": "/assets/changelogs/landing.jpg",
      "imageAlt": "Aperçu de la page d'accueil korum.studio"
    },
    {
      "version": "0.26.0",
      "date": "2026-05-19",
      "type": "minor",
      "category": "feature",
      "slug": "pricing-custom-plan-rework",
      "title": "Plan sur mesure mis en avant dans la grille pricing",
      "summary": "La grille tarifaire de la page d'accueil propose désormais trois plans côte à côte — Studio, Team et Custom — pour que chaque visiteur, du freelance à l'équipe mid-market, trouve une option qui lui correspond. Le plan sur mesure dispose de son propre CTA et d'une page dédiée pour composer librement sa configuration.",
      "highlights": [
        "Nouvelle carte « Custom » dans la grille pricing de la page d'accueil, au même niveau que Studio et Team, avec un prix « Sur devis » et un CTA « Configurer ton plan »",
        "Page « Configure your plan » repositionnée comme plan sur mesure composable : eyebrow « CUSTOM PLAN » / « PLAN SUR MESURE », sous-titre orienté workspaces, sièges et débats concurrents",
        "Section « Available plans » en bas du configurateur recentrée sur Studio et Team comme alternatives self-serve",
        "Libellés et meta-données harmonisés en français et en anglais, avec tutoiement systématique en français (« Configure ton plan », « Ce plan est adapté à ta configuration »)"
      ],
      "imageUrl": "/assets/changelogs/text-pricing-plan.png",
      "imageAlt": "Aperçu de la grille pricing avec le plan Custom"
    },
    {
      "version": "0.25.0",
      "date": "2026-05-19",
      "type": "minor",
      "category": "feature",
      "slug": "landing-pricing-config-polish",
      "title": "Pages publiques peaufinées : transitions douces, pricing plus clair et configurateur réactif",
      "summary": "Les pages publiques gagnent en cohérence et en douceur : navigation entre pages avec un fondu discret, animations de la page d'accueil apaisées, libellés des plans plus explicites, et configurateur de plan dont les curseurs et le prix estimé se mettent à jour en direct.",
      "highlights": [
        "Navigation entre pages publiques (Accueil, Docs, About, Configure your plan, Verdict, Mentions légales…) accompagnée d'un fondu doux, sans saut ni flash",
        "Animation de la table ronde de la page d'accueil ralentie pour une lecture plus posée du panel de personas",
        "Cartes Protocol (« Pick a method ») : ligne « Best for » mieux mise en page quand la valeur est longue, lisible sur mobile comme sur desktop",
        "Page Verdict de démonstration entièrement traduite en français et en anglais (titre, citation, méta, appels à l'action)",
        "Pricing de la page d'accueil : boutons « Choose Studio » et « Choose Team » accompagnés d'un libellé « Coming soon », et bouton Enterprise « Book a demo » qui redirige vers le configurateur",
        "Page Configure your plan : bascule Mensuel / Annuel avec économie de 20 % mise en avant, et prix localisés en euros selon la langue active",
        "Configurateur de plan : chaque déplacement de curseur (workspaces, personas, segments, débats simultanés, personas customs) ajuste la valeur affichée et le prix estimé en temps réel",
        "Configurateur de plan : le prix estimé fond désormais en place lors de chaque mise à jour, sans décalage horizontal ni saut de la mise en page"
      ],
      "imageUrl": "/assets/changelogs/landing.jpg",
      "imageAlt": "Aperçu des pages publiques avec la navigation et la section pricing"
    },
    {
      "version": "0.24.0",
      "date": "2026-05-19",
      "type": "minor",
      "category": "feature",
      "slug": "configure-plan-legal-polish",
      "title": "Configurateur de plan plus fluide et pages légales finalisées",
      "summary": "La page « Configure your plan » devient plus agréable à utiliser, avec des curseurs intuitifs, une estimation de prix qui réagit en temps réel et un formulaire de devis orienté équipe commerciale. Les pages légales (Mentions légales, Conditions, Confidentialité, Cookies) affichent désormais toutes les informations officielles requises.",
      "highlights": [
        "Configurateur de plan : remplacement des saisies numériques par des curseurs lisibles en mode clair comme en mode sombre, avec valeur courante toujours visible à côté de chaque réglage",
        "Estimation de prix mise à jour instantanément à chaque ajustement de curseur, pour comprendre immédiatement l'impact de chaque choix",
        "Formulaire de devis enrichi : nouveaux champs « taille de l'entreprise » et « clientèle à sonder », titre et CTA orientés démo (« Demander une démo »), promesse de réponse sous 24 h",
        "Pages Mentions légales, Conditions, Confidentialité et Cookies complétées avec les coordonnées officielles de l'éditeur (raison sociale, adresse, SIRET, code APE, directeur de la publication)",
        "Page Cookies : ajout d'une ligne dédiée à Vercel Web Analytics (mesure sans cookie) et clarification du lien « Gérer mes cookies » dans le pied de page",
        "Curseurs de la fiche persona repensés pour rester lisibles dans les deux thèmes"
      ],
      "imageUrl": "/assets/changelogs/text-pricing-plan.png",
      "imageAlt": "Aperçu de la page Configure your plan avec ses curseurs et son estimation"
    },
    {
      "version": "0.23.0",
      "date": "2026-05-19",
      "type": "minor",
      "category": "feature",
      "slug": "pricing-verdict-pages-fixes",
      "title": "Page de configuration de plan, verdict de démonstration et débats à nouveau opérationnels",
      "summary": "Deux nouvelles pages publiques pour mieux découvrir Korum avant de s'inscrire : un configurateur de plan dédié et un verdict de démonstration complet. Les débats lancés depuis l'application fonctionnent à nouveau de bout en bout.",
      "highlights": [
        "Nouvelle page « Configure your plan » accessible depuis la section pricing de la page d'accueil : ajustez vos besoins, obtenez un tarif estimé en direct et envoyez votre demande de devis sans quitter la page",
        "Nouvelle page « View a full verdict » : un verdict de démonstration complet (titre éditorial, citation d'une persona, insights, frictions, témoignage) pour comprendre concrètement ce que Korum produit",
        "Lancement de débat à nouveau fonctionnel : la suggestion automatique de nom et le déroulé des tours fonctionnent de bout en bout, fini les erreurs au démarrage",
        "Documentation publique : chaque étape (vue d'ensemble, création de persona, segment, lancement de débat, lecture de verdict) reçoit un espace visuel dédié pour mieux se repérer",
        "Mentions « gratuit » retirées des appels à l'action publics : les boutons « Start free » deviennent « Request access » / « Get started » sur la page d'accueil et la navigation"
      ],
      "imageUrl": "/assets/changelogs/text-pricing-plan.png",
      "imageAlt": "Aperçu du configurateur de plan et du verdict de démonstration"
    },
    {
      "version": "0.22.0",
      "date": "2026-05-19",
      "type": "minor",
      "category": "feature",
      "slug": "pricing-rework-and-i18n-fix",
      "title": "Nouvelle grille tarifaire et devis sur mesure",
      "summary": "La section pricing de la page d'accueil est entièrement refondue : trois plans clairs (Studio, Team, Enterprise) avec quotas explicites, et un configurateur en ligne pour estimer un devis sur mesure et recevoir un récapitulatif par e-mail. Les textes des pages publiques s'affichent désormais correctement, sans fragment de code visible.",
      "highlights": [
        "Trois plans côte à côte sur la page d'accueil : Studio (200 €/mois), Team (500 €/mois) et Enterprise (sur devis), avec leurs quotas détaillés (workspaces, personas simultanés, segments, débats simultanés, personas customs)",
        "Nouveau configurateur Enterprise : ajustez vos besoins en direct et obtenez un tarif indicatif qui se met à jour à chaque modification",
        "Demande de devis envoyée en quelques clics, avec un récapitulatif complet de votre configuration reçu par e-mail",
        "Pages publiques (À propos, Confidentialité, Conditions, Cookies, Mentions légales) : le contenu s'affiche enfin correctement, fini les bouts de code visibles à la place du texte",
        "Topbar des pages publiques alignée : boutons « Book a demo » et « Log in » désormais lisibles partout"
      ],
      "imageUrl": "/assets/changelogs/text-pricing-plan.png",
      "imageAlt": "Aperçu de la grille tarifaire avec les plans Studio, Team et Enterprise"
    },
    {
      "version": "0.21.0",
      "date": "2026-05-18",
      "type": "minor",
      "category": "feature",
      "slug": "debate-live-turn-streaming",
      "title": "Débats en direct : voyez chaque persona prendre la parole en temps réel",
      "summary": "Le déroulement d'un débat devient visible : dès le lancement, vous arrivez directement dans la salle et observez chaque persona du panel s'exprimer une à une, avec un repère visuel qui relie ceux qui se répondent.",
      "highlights": [
        "Le tour d'ouverture se joue désormais sous vos yeux dans la salle de débat, persona après persona, plutôt qu'en arrière-plan avant l'arrivée",
        "La carte de la persona qui parle est mise en avant avec un badge LIVE, et le panneau d'insights défile automatiquement vers la prise de parole en cours",
        "Lors des confrontations, un trait relie visuellement la persona qui répond à celle qu'elle adresse, pour comprendre l'échange d'un coup d'œil",
        "Bandeau de progression « Opening round · k of N personas » qui s'actualise à chaque prise de parole",
        "Reprise propre du tour d'ouverture si vous rechargez la page ou perdez la connexion : aucune intervention manuelle nécessaire"
      ],
      "imageUrl": "/assets/changelogs/debates.jpg",
      "imageAlt": "Aperçu de la salle de débat avec les prises de parole en temps réel"
    },
    {
      "version": "0.20.0",
      "date": "2026-05-18",
      "type": "minor",
      "category": "feature",
      "slug": "platform-essentials",
      "title": "Notifications repensées, email de bienvenue et formulaire de contact fiabilisé",
      "summary": "Les notifications de l'application adoptent la direction artistique de Korum et s'affichent désormais en haut à droite, sous la topbar. Les nouveaux inscrits reçoivent un email de bienvenue qui les guide vers leur premier panel, et le formulaire de contact public achemine vos messages de façon fiable.",
      "highlights": [
        "Nouvelles notifications dans l'application : design épuré, position haut-droite sous la topbar, icône sémantique et fin de fond coloré en aplat",
        "Email de bienvenue envoyé après la création d'un compte, avec un accès direct à l'application et à la documentation",
        "Formulaire de contact de la page À propos : envois fiabilisés et message de confirmation clair après soumission",
        "Aperçus de lien enrichis quand vous partagez korum.studio sur LinkedIn, Slack ou X (image, titre et description)"
      ],
      "imageUrl": "/assets/changelogs/ui-polish-batch.jpg",
      "imageAlt": "Aperçu des notifications Korum affichées sous la topbar"
    },
    {
      "version": "0.19.0",
      "date": "2026-05-18",
      "type": "minor",
      "category": "feature",
      "slug": "profile-gdpr-data-export",
      "title": "Privacy — request data export",
      "summary": "Members can now download a complete copy of their account data directly from the Account page, in compliance with GDPR Art. 15 and Art. 20.",
      "highlights": [
        "New Privacy section in Account settings: one-click data export in JSON format",
        "Export includes profile, workspaces, panels, segments, personas, debates, verdicts, and activity log",
        "60-second cooldown after each export request",
        "Partial-error banner when some data sections are temporarily unavailable",
        "Export event logged to workspace activity log (gdpr_export_requested)",
        "Site en ligne à nouveau correctement affiché : les pages publiques rendent bien le contenu au lieu d'un écran de code brut",
        "Mises en ligne à nouveau fluides : les nouvelles versions du site se déploient sans erreur de configuration",
        "Page d'accueil et bandeau cookies : plus d'erreur au chargement, l'interface s'affiche directement sans écran figé"
      ],
      "fixes": [
        {
          "slug": "fix-csp-unsafe-eval",
          "date": "2026-05-18"
        }
      ],
      "imageUrl": "/assets/changelogs/legal.jpg",
      "imageAlt": "Aperçu de l'export des données personnelles depuis la page Compte"
    },
    {
      "version": "0.17.0",
      "date": "2026-05-17",
      "type": "minor",
      "category": "feature",
      "slug": "ui-polish-batch",
      "title": "Pages publiques peaufinées : footer partout, contenus complets et aperçu de statut",
      "summary": "Une passe de finition sur les pages publiques : le footer apparaît désormais aussi sur le Changelog, la connexion ne défile plus inutilement, et un aperçu de l'état des services s'affiche au survol du badge de statut.",
      "highlights": [
        "Footer complet ajouté en bas de la page Changelog, avec accès direct aux liens de navigation, mentions légales et statut",
        "Page de connexion : plus de barre de défilement parasite quand le formulaire tient à l'écran",
        "Aperçu instantané de l'état des services (IA et déploiement) au survol du badge de statut dans le footer",
        "Documentation : chaque étape porte un libellé clair (Source, Vérifier, Panel, Lancer…) au lieu d'un simple numéro répété",
        "Page À propos : contenus complets, espacement des sections retravaillé et coquille « Quorum » corrigée en « Korum »",
        "Lancement d'un débat : le champ « Nom » reste éditable pendant la suggestion automatique, et votre saisie manuelle est toujours préservée même si la suggestion échoue"
      ],
      "imageUrl": "/assets/changelogs/ui-polish-batch.jpg",
      "imageAlt": "Aperçu des pages publiques avec leur footer et l'encart de statut"
    },
    {
      "version": "0.16.0",
      "date": "2026-05-17",
      "type": "minor",
      "category": "feature",
      "slug": "changelog-illus-debate-polish",
      "title": "Changelog illustré et debates plus lisibles",
      "summary": "Le journal des versions peut désormais afficher une illustration par release, et la liste des débats gagne en lisibilité avec des cartes plus larges et un repère « Live » plus discret.",
      "highlights": [
        "Illustration optionnelle en tête de chaque entrée de la page Changelog",
        "Cartes de débats élargies et mieux espacées sur mobile, tablette et desktop",
        "Les débats en cours se repèrent uniquement par le badge « Live », sans aplat coloré sur toute la carte",
        "Journal des versions épuré : les correctifs sont désormais regroupés dans la version concernée plutôt que listés à part",
        "Page d'accueil : visuel de fond du hero correctement affiché derrière le texte, avec un fondu progressif"
      ],
      "imageUrl": "/assets/changelogs/changelogs-illus.jpg",
      "imageAlt": "Aperçu du journal des versions illustré et de la liste des débats"
    },
    {
      "version": "0.15.0",
      "date": "2026-05-17",
      "type": "minor",
      "category": "feature",
      "slug": "landing-and-static-pages",
      "title": "Nouvelles pages publiques et navigation finalisee",
      "summary": "La page d'accueil est completee par cinq nouvelles pages publiques (Docs, About, Privacy, Terms, Status) et une navigation entierement fonctionnelle, du menu principal jusqu'au pied de page.",
      "highlights": [
        "Pages Docs, About, Privacy, Terms et Status accessibles depuis la nav et le footer",
        "Formulaire de contact sur la page About pour envoyer un message en quelques secondes",
        "Page Status qui affiche en direct la disponibilite de l'infrastructure (moteur IA et deploiement)",
        "Scroll fluide sur toute l'experience et apparitions progressives au defilement",
        "Table ronde de la page d'accueil : courbe recentrée et locuteur qui change vraiment à chaque tour",
        "Page de connexion : plus de scroll parasite et bouton Google centré"
      ],
      "imageUrl": "/assets/changelogs/legals.jpg",
      "imageAlt": "Aperçu des nouvelles pages publiques Docs, About, Privacy, Terms et Status"
    },
    {
      "version": "0.14.0",
      "date": "2026-05-17",
      "type": "minor",
      "category": "feature",
      "slug": "debates-page-overhaul",
      "title": "Nouvelle page Debates : tous vos débats en un seul endroit",
      "summary": "La rubrique Debates devient une vraie vue d'ensemble : retrouvez tous vos débats regroupés par projet, recherchez-en un en quelques frappes, et repérez en permanence ceux qui tournent en direct depuis le panneau latéral.",
      "highlights": [
        "Liste centralisée de tous les débats du workspace, regroupés par projet",
        "Recherche instantanée par nom, question ou identifiant court (DEB-NNN)",
        "Statut clair sur chaque débat : Live, en pause, terminé, échoué ou brouillon",
        "Panneau « Ongoing debates » dans la barre latérale qui suit en temps réel les débats en cours dans tous vos workspaces, avec bascule automatique de workspace au clic"
      ],
      "imageUrl": "/assets/changelogs/debates.jpg",
      "imageAlt": "Aperçu de la page Debates avec les débats regroupés par projet"
    },
    {
      "version": "0.13.0",
      "date": "2026-05-17",
      "type": "minor",
      "category": "feature",
      "slug": "debate-first-round-personas",
      "title": "Ouverture du débat : tout le panel s'exprime au premier tour",
      "summary": "Au lancement d'un débat, chaque persona du panel prend désormais la parole une fois dans le tour d'ouverture, au lieu d'un seul. La progression et la possibilité d'annuler sont visibles pendant la séquence.",
      "highlights": [
        "Indicateur de progression « Opening round · k of n personas » pendant le lancement",
        "Bouton Annuler disponible pendant le tour d'ouverture",
        "Reprise automatique du tour d'ouverture si une partie a échoué, sans doublon",
        "Bandeau d'information quand un tour d'ouverture est en cours côté serveur"
      ],
      "imageUrl": "/assets/changelogs/debates.jpg",
      "imageAlt": "Aperçu du tour d'ouverture d'un débat avec tout le panel de personas"
    },
    {
      "version": "0.12.0",
      "date": "2026-05-17",
      "type": "minor",
      "category": "feature",
      "slug": "public-changelogs-page",
      "title": "Page Changelog publique accessible depuis la landing",
      "summary": "Une nouvelle page /changelogs liste publiquement toutes les versions de korum studio, accessible depuis la navigation et le footer de la page d'accueil.",
      "highlights": [
        "Lien Changelog de la nav et du footer désormais fonctionnel",
        "Chaque release affiche sa version, sa date, son type et ses points saillants",
        "Lecture fluide sur mobile comme sur desktop"
      ],
      "imageUrl": "/assets/changelogs/changelogs.jpg",
      "imageAlt": "Aperçu de la page Changelog publique listant les versions"
    },
    {
      "version": "0.11.0",
      "date": "2026-05-14",
      "type": "minor",
      "category": "feature",
      "slug": "public-docs-and-legal",
      "title": "Documentation publique, changelogs, contact et pages légales",
      "summary": "korum.studio s'ouvre au public avec un ensemble complet de pages institutionnelles : documentation produit, journal des versions, formulaire de contact et pages légales (mentions, confidentialité, conditions).",
      "highlights": [
        "Documentation publique du produit accessible sans compte",
        "Page Changelogs publique listant toutes les versions livrées",
        "Formulaire de contact public pour joindre l'équipe en quelques clics",
        "Pages légales en place : mentions légales, politique de confidentialité, conditions d'utilisation"
      ],
      "imageUrl": "/assets/changelogs/legal.jpg",
      "imageAlt": "Aperçu des pages publiques de documentation et des pages légales"
    },
    {
      "version": "0.10.0",
      "date": "2026-04-29",
      "type": "minor",
      "category": "feature",
      "slug": "workspaces-system",
      "title": "Workspaces : gérez plusieurs entreprises clientes en parallèle",
      "summary": "korum studio devient multi-workspace : créez un espace par entreprise cliente et basculez en un clic entre vos différents périmètres, sans jamais mélanger personas, projets ni débats.",
      "highlights": [
        "Création de plusieurs workspaces par compte",
        "Personas, segments, projets et débats parfaitement isolés par workspace",
        "Bascule rapide entre workspaces depuis la barre latérale",
        "Pensé pour les agences et freelances qui jonglent entre plusieurs clients"
      ],
      "imageUrl": "/assets/changelogs/workspaces.jpg",
      "imageAlt": "Aperçu du sélecteur de workspaces avec plusieurs entreprises clientes"
    },
    {
      "version": "0.9.0",
      "date": "2026-04-14",
      "type": "minor",
      "category": "feature",
      "slug": "verdicts-system",
      "title": "Verdicts : rapport complet et pré-analyse de chaque débat",
      "summary": "Chaque débat se conclut désormais par un « Verdict » : un rapport complet incluant une pré-analyse synthétique des prises de position et le transcript intégral des échanges entre personas.",
      "highlights": [
        "Pré-analyse synthétique des positions du panel",
        "Transcript complet des échanges entre personas",
        "Identification automatique des consensus et des points de friction",
        "Verdict consultable, exportable et partageable avec l'équipe"
      ],
      "imageUrl": "/assets/changelogs/verdicts.jpg",
      "imageAlt": "Aperçu d'un verdict avec sa pré-analyse et le transcript du débat"
    },
    {
      "version": "0.8.0",
      "date": "2026-03-30",
      "type": "minor",
      "category": "feature",
      "slug": "debates-system-simple",
      "title": "Premiers débats : testez vos idées avec un panel de personas",
      "summary": "Lancez un débat sur n'importe quelle idée — pricing, fonctionnalité, retour UX, feedback utilisateur — et obtenez les réactions argumentées d'un panel de personas. Première version éprouvée en interne sur korum.studio lui-même.",
      "highlights": [
        "Lancement d'un débat à partir d'une question libre",
        "Panel constitué à partir de vos segments et personas",
        "Cas d'usage validés en interne : pricing, features, retours UX, feedbacks utilisateurs",
        "Restitution des prises de parole de chaque persona dans une vue de débat dédiée"
      ],
      "imageUrl": "/assets/changelogs/debates.jpg",
      "imageAlt": "Aperçu d'un débat avec les réactions argumentées du panel de personas"
    },
    {
      "version": "0.7.0",
      "date": "2026-03-15",
      "type": "minor",
      "category": "feature",
      "slug": "projects-system",
      "title": "Projets : centralisez brief, Figma, transcripts et liens externes",
      "summary": "La nouvelle entité « Projet » regroupe tout le contexte d'une initiative : brief produit, lien Figma, transcript vidéo ou tout lien externe utile. Ce contexte est ensuite mobilisé automatiquement dans les débats du projet.",
      "highlights": [
        "Création de projets avec brief structuré",
        "Attachement de liens Figma directement au projet",
        "Import de transcripts vidéo comme matériel de contexte",
        "Liens externes libres (Notion, docs, articles) attachés au projet",
        "Tout le matériel du projet est mobilisé automatiquement dans les débats"
      ],
      "imageUrl": "/assets/changelogs/projects.jpg",
      "imageAlt": "Aperçu d'un projet regroupant brief, lien Figma et transcripts"
    },
    {
      "version": "0.6.0",
      "date": "2026-02-28",
      "type": "minor",
      "category": "feature",
      "slug": "segments-system",
      "title": "Segments : regrouper et personnaliser des ensembles de personas",
      "summary": "Vous pouvez maintenant regrouper plusieurs personas dans des « segments » thématiques, et personnaliser librement la composition de chaque segment pour cibler une audience précise lors d'un débat.",
      "highlights": [
        "Création de segments par cible (early adopters, décideurs, utilisateurs finaux, etc.)",
        "Composition libre des personas dans chaque segment",
        "Réutilisation des segments entre projets pour gagner du temps",
        "Affinage du panel persona par persona avant le lancement d'un débat"
      ],
      "imageUrl": "/assets/changelogs/segments.jpg",
      "imageAlt": "Aperçu d'un segment regroupant plusieurs personas"
    },
    {
      "version": "0.5.0",
      "date": "2026-02-13",
      "type": "minor",
      "category": "feature",
      "slug": "personas-system",
      "title": "Système de personas et bibliothèque issue de nos recherches",
      "summary": "korum studio embarque désormais un système complet de personas réutilisables, accompagné d'une première bibliothèque construite à partir de nos recherches utilisateurs terrain.",
      "highlights": [
        "Création, édition et duplication de personas",
        "Bibliothèque initiale de personas issus de nos recherches",
        "Profil détaillé : rôle, contexte, motivations, frictions, ton de voix",
        "Réutilisation des personas dans les futurs débats et projets"
      ],
      "imageUrl": "/assets/changelogs/personas.jpg",
      "imageAlt": "Aperçu de la bibliothèque de personas de korum studio"
    },
    {
      "version": "0.4.0",
      "date": "2026-01-29",
      "type": "minor",
      "category": "feature",
      "slug": "status-page-initial",
      "title": "Page Status : disponibilité de l'infrastructure en direct",
      "summary": "Une première page publique /status permet de consulter en temps réel l'état des composants critiques de korum studio (API, moteur IA, base de données), avec un lien vers la page d'incidents détaillée.",
      "highlights": [
        "État live des principaux composants (API, moteur IA, base de données)",
        "Indicateur global de disponibilité du service",
        "Lien vers la page d'incidents pour aller plus loin"
      ],
      "imageUrl": "/assets/changelogs/status.jpg",
      "imageAlt": "Aperçu de la page Status avec l'état des composants critiques"
    },
    {
      "version": "0.3.0",
      "date": "2026-01-14",
      "type": "minor",
      "category": "feature",
      "slug": "backend-infrastructure",
      "title": "Mise en place de l'infrastructure back-end",
      "summary": "Déploiement de l'infrastructure serveur de korum studio : API de production, environnements preview/prod séparés et pipeline de déploiement continu sont désormais opérationnels et prêts à accueillir les fonctionnalités produit.",
      "highlights": [
        "API de production déployée et accessible",
        "Séparation claire des environnements preview et production",
        "Pipeline de déploiement continu en place",
        "Surveillance basique des erreurs et des performances"
      ],
      "imageUrl": "/assets/changelogs/status.jpg",
      "imageAlt": "Aperçu de l'état des services de l'infrastructure korum studio"
    },
    {
      "version": "0.2.0",
      "date": "2025-12-30",
      "type": "minor",
      "category": "feature",
      "slug": "auth-and-database-setup",
      "title": "Création de compte et connexion (e-mail / Google)",
      "summary": "Mise en place du socle d'authentification de korum studio : création de compte, connexion par e-mail/mot de passe et connexion en un clic via Google, adossées à une base de données utilisateurs sécurisée.",
      "highlights": [
        "Inscription et connexion par e-mail/mot de passe",
        "Connexion en un clic via Google",
        "Base de données utilisateurs sécurisée pour persister les comptes",
        "Page de connexion dédiée avec gestion claire des erreurs"
      ],
      "imageUrl": "/assets/changelogs/auth.jpg",
      "imageAlt": "Aperçu de l'écran de connexion par e-mail ou via Google"
    },
    {
      "version": "0.1.0",
      "date": "2025-12-15",
      "type": "minor",
      "category": "feature",
      "slug": "landing-page-initial",
      "title": "Première page d'accueil publique de korum studio",
      "summary": "Mise en ligne d'une première version de la page d'accueil korum.studio : vitrine du produit avec hero, présentation des principes de débats multi-personas et premier appel à l'action.",
      "highlights": [
        "Hero avec proposition de valeur et appel à l'action principal",
        "Présentation du produit et de ses principes de débats multi-personas",
        "Mise en ligne du domaine korum.studio"
      ],
      "imageUrl": "/assets/changelogs/landing.jpg",
      "imageAlt": "Aperçu de la première page d'accueil publique de korum studio"
    }
  ]
}
